import React from 'react';

interface DonutChartScoreProps {
  score: number;
  maxValue?: number;
}

const DonutChartScore: React.FC<DonutChartScoreProps> = ({ score, maxValue = 10 }) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (score / maxValue) * circumference;

  const fullColor = '#065F46';
  const emptyColor = '#d1fae5';
  const scoreTextColor = '#374151';
  const slashTextColor = '#6B7280';

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: '112px', height: '112px', flexShrink: 0 }}
    >
      <svg width="112" height="112" viewBox="0 0 120 120">
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke={emptyColor}
          strokeWidth="10"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          stroke={fullColor}
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
      </svg>
      <div className="absolute flex flex-col items-center justify-center">
        <span className="text-4xl font-bold leading-none" style={{ color: scoreTextColor }}>{score}</span>
        <span className="text-lg mt-1" style={{ color: slashTextColor }}>/ {maxValue}</span>
      </div>
    </div>
  );
};

export default DonutChartScore;
